/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {getYear, getMonth, format, parse, getDate, isValid, add, sub, getMinutes, getHours} from 'date-fns';
import parseDate from 'date-fns/parse';
import {ptBR} from 'date-fns/locale';
import isDateValid from 'date-fns/isValid';
import { DateMaskInput, Wrapper, Label } from './styles';

import { isValidISODate, convertToDate } from '../../utils/date';
import Toast from '../Toast';

interface IDateInputProps {
    id: string;
    name: string;
    label: string;
    value: any;
    withHour: boolean;
    onChange(event: any): void;
    require?: boolean;
    inTable?: boolean;
    disabled?: boolean;
    error?: boolean;
}

const DateInput: React.FC<IDateInputProps> = ({
  id,
  name,
  label,
  value,
  withHour,
  onChange,
  inTable,
  disabled,
  require,
  error
}) => {
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [hasRendered, setHasRendered] = useState(false);
    const [noDayMask, setNoDayMask] = useState(false);
    const [currentDateMaskValue, setCurrentDateMaskValue] = useState('');
    const [enableMask, setEnableMask] = useState(true);

    useEffect(() => {
      if (startDate && typeof startDate !== 'string') {
        const isoDate = new Date(startDate.toISOString());
        if (isValidISODate(isoDate)) {

            if (withHour) {
                const formatedStartDate = format(isoDate, 'dd/MM/yyyy HH:mm');
                onChange({
                    target: {
                        id,
                        name,
                        value: formatedStartDate,
                    },
                });
                dateFormatInput(startDate);
            } else {
                onChange({
                    target: {
                        id,
                        name,
                        value: format(isoDate, 'dd/MM/yyyy')
                    },
                });
                dateFormatInput(startDate);
            }

        }

      } else {
        onChange({
            target: {
                id,
                name,
                value: null,
            },
        });
      }
    }, [startDate]);

    useEffect(() => {
        if (value && !hasRendered) {
            let testDate = new Date();
            const formatDateStr = value.split(' ').length > 1 ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy';
            testDate = parseDate(value, formatDateStr, new Date(), {locale: ptBR});
            if (isDateValid(testDate)) {
                setStartDate(testDate);
            } else if (isDateValid(new Date(value))) {
                const _date = new Date(value);
                setStartDate(_date);
            } else {
                const checkDate = convertToDate(value);

                if (checkDate) {
                    setStartDate(checkDate);
                }
            }
            
            setHasRendered(true);
        }
    }, [value, hasRendered]);

    const handleChangeInputMask = (event: React.FormEvent<HTMLInputElement>) => {
        setNoDayMask(false);
        const { currentTarget: {value} } = event;

        if(enableMask) {
            const currentDate = new Date();
            const currentMonth = getMonth(currentDate) + 1;
            const currentYear = getYear(currentDate);
    
            let day;
            let month;
            let date;
            let hour;
            let minute;
            //removendo mascara do input 
            const rawValue = value.replace(/[^\d]/g, '');
            const dateMask = withHour ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
            //verifica se digitou so dias
            if(rawValue.length > 0 && rawValue.length <=2) {
                day = rawValue.substring(0, 2);
                hour = rawValue.substring(8, 10) || '00';
                minute = rawValue.substring(10, 12) || '00';
                let dateStr = `${currentYear}-${currentMonth}-${day}`;
                if (withHour) dateStr += ` ${hour}:${minute}`;
                date = parse(dateStr, dateMask, new Date());
                if(isValid(date)) {
                    setStartDate(date);
                    dateFormatInput(date);
                } else {
                    Toast.show("Digite uma data válida");
                }
            } else if(rawValue.length > 0 && rawValue.length <= 4) {
                day = rawValue.substring(0, 2);
                month = rawValue.substring(2, 4);
                hour = rawValue.substring(8, 10) || '00';
                minute = rawValue.substring(10, 12) || '00';
                let dateStr = `${currentYear}-${month}-${day}`;
                if (withHour) dateStr += ` ${hour}:${minute}`;
                date = parse(dateStr, dateMask, new Date());
                if(isValid(date)) {
                    setStartDate(date);
                    dateFormatInput(date);
                } else {
                    Toast.show("Digite uma data válida");
                }
            } else if(rawValue.length >= 8) {
                day = rawValue.substring(0, 2);
                month = rawValue.substring(2, 4);
                const year = `20${rawValue.substring(4, 6)}`;
                hour = rawValue.substring(6, 8) || '00';
                minute = rawValue.substring(8, 10) || '00';
                let dateStr = `${year}-${month}-${day}`;
                if (withHour) {
                    dateStr += ` ${hour}:${minute}`;
                }
                date = parse(dateStr, dateMask, new Date());
                if(isValid(date)) {
                    setStartDate(date);
                    dateFormatInput(date);
                } else {
                    Toast.show("Digite uma data válida");
                }
            }
        } else {
            if(value.includes("+")) {
                const days = value.replaceAll("+", "");
                const newDate = add(new Date(), {days: Number.parseInt(days)});
                newDate.setHours(0, 0, 0);

                if(isValid(newDate)) {
                    setStartDate(newDate);
                    dateFormatInput(newDate);
                }

            } else if(value.includes("-")) {
                const days = value.replaceAll("-", "");
                const newDate = sub(new Date(), {days: Number.parseInt(days)});
                newDate.setHours(0, 0, 0);
                
                if(isValid(newDate)) {
                    setStartDate(newDate);
                    dateFormatInput(newDate);
                }
            }
            setEnableMask(true);
        }

    }

    const handleShortcutData = (event: any) => {
        const {key} = event;
        
        if (key === 'Backspace') {
            setEnableMask(false);
            setCurrentDateMaskValue('');
            onChange({
                target: {
                    id,
                    name,
                    value: null,
                },
            });
        }

        if(key === '+' || key === '-') {
            setEnableMask(false);
            setCurrentDateMaskValue('');
        }

        if(key === 'h' || key === 'H') {
            const _date = new Date();
            if(isValid(_date)) {
                setStartDate(_date);
                toNextInput(event);
            }
            
        } else if(key === 'a' || key === 'A') {
            const _date = add(new Date(), {days: 1});
            if(isValid(_date)) {
                setStartDate(_date);
                toNextInput(event);
            }

        } else if(key === 'o' || key === 'O') {
            const _date = add(new Date(), {days: -1});
            if(isValid(_date)) {
                setStartDate(_date);
                toNextInput(event);
            }
        }
    }

    const toNextInput = (event: any) => {
        const form = event.target.form;
        const index = [...form].indexOf(event.target);
        if(index + 1) {
            //adicionando um delay para evitar que a troca de focus seja feita antes do state mudar
            setTimeout(() => form.elements[index + 1].focus(), 150);
        }
    }

    const handleOnFocus = (event: any) => {
        event.target.select();
        setNoDayMask(true);
    }

    const dateFormatInput = (date: any) => {
        setNoDayMask(false);
        const _day = getDate(date) < 10 ? '0'+getDate(date) : getDate(date);
        const _month = (getMonth(date)+1) < 10 ? '0'+(getMonth(date)+1) : (getMonth(date)+1);

        const weekDay = format(date, 'eeeeee', {
            locale: ptBR,
          });
        let strStateDate = `${_day}${_month}${getYear(date).toString().substring(2, 4)}`;
        if (withHour) {
            const _hour = (getHours(date) < 10 ? '0'+getHours(date) : getHours(date));
            const _minute = (getMinutes(date) < 10 ? '0'+getMinutes(date) : getMinutes(date));
            strStateDate += `${weekDay}${_hour}${_minute}`;
        } else {
            strStateDate += `${weekDay}`;
        }
        setCurrentDateMaskValue(strStateDate);
    }

    const resetCurrentDateMask = (event: React.FormEvent<HTMLInputElement>) => {
        const { currentTarget: {value} } = event;
        
        setCurrentDateMaskValue(value);
    }

    function getMask() {
        if (!enableMask) return "";
        if (noDayMask) {
            if (withHour) {
                return "99/99/99 99:99";
            } else {
                return "99/99/99";
            }
        } else {
            if (withHour) {
                return "99/99/99 aaa 99:99";
            } else {
                return "99/99/99 aaa";
            }
        }
    }
    
    return (
        <Wrapper>
            {!inTable && (
                <Label error={error ? true : false} bold={require}>
                    {label} {error ? (<span>(* {error})</span>) : require ? <span> *</span> : null}
                </Label>
            )}
            <DateMaskInput 
            value={currentDateMaskValue}
            disabled={disabled}
            mask={getMask()}
            onBlur={handleChangeInputMask}
            onFocus={handleOnFocus}
            onChange={resetCurrentDateMask}
            onKeyDown={handleShortcutData}
            />
        </Wrapper>
    );
}

export default DateInput;